import { render } from "./CustomColorPicker.vue?vue&type=template&id=161e0378&scoped=true"
import script from "./CustomColorPicker.vue?vue&type=script&lang=js"
export * from "./CustomColorPicker.vue?vue&type=script&lang=js"

import "./CustomColorPicker.vue?vue&type=style&index=0&id=161e0378&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161e0378"]])

export default __exports__